// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../components/Elemental'
import _ from 'lodash'
import { NavLink } from 'react-router-dom'
import { reduxForm, Field, FieldArray, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'

// CSS
import './styles.scss'

// Components/Containers
import Attention from '../../components/Attention'
import Breadcrumb from '../../components/Breadcrumb'
import Button from '../../components/Button'
import Form from '../../components/Form'
import Input from '../../components/Input'
import Tag from '../../components/Tag'
import Label from '../../components/Label'
import MessageCard from '../../components/MessageCard'
import Select from '../../components/Select'
import Warning from '../Warning'
import MessageBox from '../MessageBox'

// Normalize
import * as normalize from '../../constants/normalize'

// Options
import * as options from '../../constants/options'

// Validate
import { required, selected, email, minLength25 } from '../../constants/validate'

// Others
import { getLawsuitSegment } from '../../constants/others'

// Actions
import { changeLawyer, changeCompany, changeNewInvitationClassifiers, changeOptional, fetchLawyer, fetchNewInvitationClassifiers, newInvitation } from './actions'
import { change, reset } from 'redux-form'

class NewInvitation extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { lawyer, company, optional, changeNewInvitationClassifiers, changeOptional, fetchNewInvitationClassifiers, change } = this.props
    const nextLawyer = nextProps.lawyer
    const nextCompany = nextProps.company

    if (lawyer !== nextLawyer) {
      if (!_.isEmpty(nextLawyer)) {
        change('lawyerName', nextLawyer.name + ' ' + nextLawyer.surname)
        change('lawyerEmail', nextLawyer.email)
        change('lawyerPhone', nextLawyer.phone)

      } else if (!_.isEmpty(lawyer) && _.isEmpty(nextLawyer)) {
        change('lawyerName', '')
        change('lawyerSurname', '')
        change('lawyerEmail', '')
        change('lawyerPhone', '')
      }
    }

    // TODO: Temporary solution for "Banco Olé Consignado" and "Banco Fibra" and "Liberty"
    if (company.value !== nextCompany.value) {
      changeNewInvitationClassifiers([])

      if (!nextCompany.value) return

      if (nextCompany.value === 'Banco Olé Consignado') {
        changeNewInvitationClassifiers([{ "value": 10, "label": "Pré-Sentença" }, { "value": 11, "label": "Pós-Sentença" }])
        changeOptional({ ...optional, ps: false, classifiers: false })
      } else if (nextCompany.value === 'Banco Fibra') {
        changeNewInvitationClassifiers([{ "value": 20, "label": "Indenizatórias" }, { "value": 21, "label": "Revisional de Contrato" }, { "value": 22, "label": "Busca e Apreenção" }, { "value": 23, "label": "Outros" }])
        changeOptional({ ...optional, ps: false, classifiers: false })
      } else if (nextCompany.value === 'Indiana Seguros S/A' || nextCompany.value === 'Liberty Seguros S/A' || nextCompany.value === 'FacilAssist Serv. E Assist. 24 horas Ltda.') {
        changeNewInvitationClassifiers([{ "value": 130, "label": "Anuência" }, { "value": 131, "label": "Salvado" }, { "value": 132, "label": "Menor Envolvido" }, { "value": 133, "label": "Defesa do Segurado" }, { "value": 134, "label": "Salvados (Salvado ficando com o autor)" }, { "value": 135, "label": "Salvados (Salvado ficando com a Cia)" }, { "value": 136, "label": "Demais Casos" }])
        changeOptional({ ...optional, ps: true, classifiers: false })
      } else {
        fetchNewInvitationClassifiers(nextCompany.id)
      }
    }
  }

  componentWillUnmount() {
    const { user, changeCompany, changeNewInvitationClassifiers } = this.props

    changeCompany('')

    // TODO: Temporary solution for "Banco Olé Consignado" and "Banco Fibra" and "Liberty"
    changeNewInvitationClassifiers([])
  }

  handleFormSubmit = (reduxFormData) => {
    const { user: { id }, company, newInvitation } = this.props
    const formData = { ...reduxFormData, id, companyId: company.id }

    return newInvitation(formData)
  }

  render() {
    const {
      lawsuitNumber,
      maxValue,
      oabNumber,
      oabUf,
      message,
      localLoading,
      user,
      lawyer,
      company,
      optional,
      classifiers,
      changeLawyer,
      changeCompany,
      fetchLawyer,
      change,
      handleSubmit } = this.props

    const selectedUf = value => options.uf.some(uf => uf.value === value) ? undefined : 'Opção Inexistente'
    const selectedCompany = value => user.companies.some(user => user.fantasyName === value) ? undefined : 'Opção Inexistente'

    return (
      <div className="new-invitation-page">
        <div className="new-invitation-page__header">
          <Breadcrumb routes={['Inserir Caso']} />
          {user.admin && user.manager &&
            <NavLink to="/inserir-caso-contencioso/importar"><span>Importar</span></NavLink>
          }
        </div>
        <Warning gutterBottom={20} />
        <Row>
          <Col>
            <Form autoComplete="off" onSubmit={handleSubmit(this.handleFormSubmit)}>
              <Row>
                <Col>
                  <Label gutterTop={0}>Informações do Processo Judicial</Label>
                </Col>
                <Col md="25%">
                  <Field
                    name="lawsuitNumber"
                    component={Input}
                    label="Número Processo"
                    placeholder="0000000-00.0000.0.00.0000"
                    gutter={25}
                    normalize={normalize.lawsuitNumber}
                    validate={[required, minLength25]} />
                </Col>
                <Col md="25%">
                  <Field
                    name="lawsuitUf"
                    component={Select}
                    label="UF Processo"
                    gutter={25}
                    options={options.uf}
                    normalize={normalize.uf}
                    validate={[required, selectedUf]} />
                </Col>
                <Col md="25%">
                  <Field
                    name="clientName"
                    component={Input}
                    label={`Nome Completo ${lawsuitNumber ? getLawsuitSegment(lawsuitNumber).clientLabel : 'Autor'}`}
                    gutter={25}
                    validate={required} />
                </Col>
                <Col md="25%">
                  <Field
                    name="companyId"
                    component={Select}
                    label={`Empresa ${lawsuitNumber ? getLawsuitSegment(lawsuitNumber).companyLabel : 'Ré'}`}
                    gutter={25}
                    handleSelect={company => changeCompany(company)}
                    handleClear={company => changeCompany({})}
                    options={user.companies
                      .filter(company => {
                        return company.fantasyName !== null
                      })
                      .map(company => {
                        return { 'id': company.id, 'value': company.fantasyName }
                      })}
                    validate={[required, selectedCompany]} />
                </Col>
                <Col>
                  <Label>Informações do Advogado do Autor</Label>
                </Col>
                <Col md="25%">
                  <Field
                    name="oabNumber"
                    component={Input}
                    label="Número OAB"
                    placeholder="000000"
                    gutter={25}
                    handleBlur={value => {
                      oabUf && fetchLawyer(value, oabUf)
                      value.length <= 6 && change('oabNumber', '0'.repeat(6 - value.length) + value)
                    }}
                    handleEnter={value => oabUf && fetchLawyer(value, oabUf)}
                    normalize={normalize.oabNumber}
                    validate={required} />
                </Col>
                <Col md="25%">
                  <Field
                    name="oabUf"
                    component={Select}
                    label="UF OAB"
                    gutter={25}
                    options={options.uf}
                    handleSelect={option => oabNumber && fetchLawyer(oabNumber, option.value)}
                    handleClear={() => changeLawyer({})}
                    normalize={normalize.uf}
                    validate={[required, selectedUf]} />
                </Col>
                <Col md="50%">
                  <Field
                    name="lawyerName"
                    component={Input}
                    label="Nome Completo"
                    gutter={25}
                    disabled={lawyer.name ? true : false}
                    validate={required} />
                </Col>
                <Col md="50%">
                  <Field
                    name="lawyerEmail"
                    component={Input}
                    type="email"
                    label="Email"
                    gutter={25}
                    secured
                    disabled={lawyer.email ? true : false}
                    validate={[required]} />
                </Col>
                <Col md="50%">
                  <Field
                    name="lawyerPhone"
                    component={Input}
                    type="phone"
                    label="Celular (Opcional)"
                    placeholder="(00)00000-0000"
                    gutter={25}
                    secured
                    disabled={lawyer.phone ? true : false}
                    normalize={normalize.phone} />
                </Col>
                <Col>
                  <Label>Informações Adicionais</Label>
                </Col>
                <Col>
                  <Attention>Estas informações adicionais não serão disponibilizadas ao advogado do autor</Attention>
                </Col>
                <Col md="25%">
                  <Field
                    name="maxValue"
                    component={Input}
                    label="Alçada"
                    placeholder="0,00"
                    gutter={25}
                    normalize={normalize.currency}
                    validate={required} />
                </Col>
                <Col md="25%">
                  <Field
                    name="provision"
                    component={Input}
                    label="Provisão (Opcional)"
                    placeholder="0,00"
                    gutter={25}
                    normalize={normalize.currency} />
                </Col>
                <Col md="25%">
                  <Field
                    name="obligation"
                    component={Input}
                    label="Outras Obrigações (Opcional)"
                    gutter={25} />
                </Col>
                <Col md="25%">
                  <Field
                    name="ps"
                    component={Input}
                    label={`Codigo Sistema${optional.ps ? ' (Opcional)' : ''}`}
                    gutter={25}
                    validate={optional.ps ? undefined : required} />
                </Col>
                {!_.isEmpty(classifiers) &&
                  <Col gutter={0}>
                    <Col>
                      <Label>Classificações{optional.classifiers ? ' (Opcional)' : ''}</Label>
                    </Col>
                    <Col>
                      <Attention>{optional.classifiers ? ' Procure sempre classificar' : 'Classifique'} os seus casos. Desta maneira, você irá organizá-los melhor e obterá novas métricas</Attention>
                    </Col>
                    <Col>
                      <Field
                        name="classifiers"
                        component={Tag}
                        options={classifiers}
                        gutter={25}
                        validate={optional.ps ? undefined : required} />
                    </Col>
                  </Col>
                }
                <Col>
                  <Label>Proposta Inicial (Opcional)</Label>
                </Col>
                <Col>
                  <Attention>Nesse momento, nós já teremos enviado a mensagem de boas vindas. O próximo passo é o envio da proposta</Attention>
                </Col>
                <Col md="75%">
                  <Row>
                    <Col>
                      <Field
                        name="message"
                        component={MessageBox}
                        placeholder="Digite aqui a proposta. Nós já lidamos com as formalidades."
                        options={[
                          { 'tag': 'pm', 'help': 'proposta máxima', 'value': maxValue },
                          { 'tag': 'adv', 'help': 'nome do advogado', 'value': lawyer.name },
                          { 'tag': 'email', 'help': 'email do advogado', 'value': lawyer.email },
                        ]}
                        gutter={25} />
                    </Col>
                    <Col>
                      <MessageCard
                        name={company.value}
                        status="2"
                        role="company"
                        createBy="company"
                        datetime={new Date()}
                        gutter={10}>
                        {message}
                      </MessageCard>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col sm="100%" md="50%" lg="25%">
                  <Button type="submit" localLoading={localLoading} gutterTop={40}>Enviar</Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    )
  }
}

NewInvitation = reduxForm({
  form: 'newInvitation',
})(NewInvitation);

const selector = formValueSelector('newInvitation')

NewInvitation = connect(
  state => {
    const lawsuitNumber = selector(state, 'lawsuitNumber')
    const maxValue = selector(state, 'maxValue')
    const oabNumber = selector(state, 'oabNumber')
    const oabUf = selector(state, 'oabUf')
    const lawyerName = selector(state, 'lawyerName')
    const message = selector(state, 'message')

    return {
      lawsuitNumber,
      maxValue,
      oabNumber,
      oabUf,
      lawyerName,
      message,
      localLoading: state.app.localLoading,
      err: state.app.err,
      success: state.app.success,
      user: state.auth.user,
      lawyer: state.newInvitationPage.lawyer,
      company: state.newInvitationPage.company,
      classifiers: state.newInvitationPage.classifiers,
      optional: state.newInvitationPage.optional,
    }
  },
  { changeLawyer, changeCompany, changeNewInvitationClassifiers, changeOptional, fetchLawyer, fetchNewInvitationClassifiers, newInvitation, change, reset }
)(NewInvitation)

export default NewInvitation
